// 已采购记录(구매기록 表三) — /api/reqpurchase/purchasedrecord 의 행을 직원이 손으로 쓰던 表三(시트 「제트배송」) 열 배치 그대로 엑셀로 쓴다.
// 순수 함수 모듈(브라우저·node 공용). 화면은 商品求购(logisreqpurchaseV0) 「已采购记录」 탭 = PurchasedRecordView.vue.
// 표와 엑셀은 같은 COLUMNS[].key 로 값을 꺼낸다(cellValue) — 칸 값이 둘 사이에 갈리지 않게.
//
// 엑셀은 시스템 저장값의 출력일 뿐이다 — 값 계산은 서버(발행 견적 / 견적 규칙)가 하고 여기선 칸에 놓기만 한다.
// 열 위치는 샘플과 같게 둔다(A~AO). 시스템에 없는 칸(요청자·cp号·辅助列·飞运手续费 등)은 제목만 두고 비운다.
// 통관방식 색 — 샘플 1행 범례와 같다: 蓝色单独 = 화주단독(M 칸), 橙色单独 = 쿠패스단독·식검(N 칸), 综合通关 = 통합통관(N 칸, 색 없음).
// 서식(채우기·글꼴)은 SheetJS 무료판이 못 써서 箱单发票(invoiceXlsx.js)의 OOXML 작성기를 그대로 쓴다.
import { Styles, Sheet, packXlsx } from './invoiceXlsx'

const BLUE = 'FF0070C0'
const ORANGE = 'FFFFC000'
const DATE_FMT = 'yyyy-mm-dd'
const KRW = '#,##0'
const CNY = '#,##0.00'
const PCT = '0.0%'

// 2행 제목 — 샘플 그대로(글자·칸 색). key = 행에서 꺼낼 값(없으면 비운다)
export const COLUMNS = [
  { col: 'A', title: '신청날짜', fill: 'FFF8CBAD', w: 11, key: r => dateCell(r.신청날짜) },
  { col: 'B', title: '업체명', fill: 'FFF8CBAD', w: 14, key: r => r.업체명 },
  { col: 'C', title: '요청자', fill: 'FFF8CBAD', w: 8 }, // 시스템에 없음(화주 측 요청자 이름)
  { col: 'D', title: '상품명', fill: 'FFF8CBAD', w: 40, key: r => r.상품명 },
  { col: 'E', title: '구매수량', fill: 'FFF8CBAD', w: 8, key: r => r.구매수량 },
  { col: 'F', title: '구매단가(CNY)', fill: 'FFF8CBAD', w: 9, fmt: CNY, key: r => r.협상전_단가 },
  { col: 'G', title: '배송비(CNY)', fill: 'FFF8CBAD', w: 9, fmt: CNY, key: r => r.협상전_배송비 },
  { col: 'H', title: '총금액(CNY)', fill: 'FFF8CBAD', w: 10, fmt: CNY, key: r => r.협상전_총금액 },
  { col: 'I', title: '확인용(협상후)\n구매단가(CNY)', fill: 'FFDBDBDB', w: 10, fmt: CNY, key: r => r.협상후_단가 },
  { col: 'J', title: '확인용(협상후)\n배송비(CNY)', fill: 'FFDBDBDB', w: 10, fmt: CNY, key: r => r.협상후_배송비 },
  { col: 'K', title: '확인용(협상후) 1688\n결제금액(CNY)', fill: 'FFDBDBDB', w: 12, fmt: CNY, key: r => r.협상후_총금액 },
  { col: 'L', title: '협상할인율(%)', fill: 'FFFCE5CD', w: 9, fmt: PCT, key: r => discountRate(r) },
  { col: 'M', title: '결제금액(KRW)', fill: 'FFFCE5CD', w: 12, fmt: KRW, key: r => (r.customsType === 'client' ? r.결제금액_KRW : '/') },
  { col: 'N', title: '결제금액(KRW)\n쿠패스 사업자통관', fill: 'FFFCE5CD', w: 13, fmt: KRW, key: r => (r.customsType === 'client' ? null : r.결제금액_KRW) },
  { col: 'O', title: '부가세', fill: 'FFFCE5CD', w: 10, fmt: KRW, key: r => r.부가세 },
  { col: 'P', title: '최종금액합계(KRW)', fill: 'FFFCE5CD', w: 12, fmt: KRW, key: r => r.최종금액합계_KRW },
  { col: 'Q', title: '적용환율', fill: 'FFFCE5CD', w: 8, fmt: '0.00', key: r => r.적용환율 },
  { col: 'R', title: '비고', fill: 'FFFCE5CD', w: 22, key: r => remark(r) },
  { col: 'S', title: '日期결제일', fill: 'FFD9EAD3', w: 11, key: r => dateCell(r.결제일) },
  { col: 'T', title: '바코드', fill: 'FFD9EAD3', w: 16, key: r => r.바코드 },
  { col: 'U', title: '주문번호', fill: 'FFD9EAD3', w: 21, key: r => r.주문번호 },
  { col: 'V', title: '辅助列', fill: 'FFE7E6E6', w: 6 },        // 샘플의 계산 보조 칸
  { col: 'W', title: 'cp号NO.', fill: 'FFFFFF00', w: 12 },      // 시스템에 없음
  { col: 'X', title: '구매상품명', fill: 'FFFCE5CD', w: 10 },   // cp号 묶음 보조 칸 — cp号가 없어 비운다
  { col: 'Y', title: '총구매수량', fill: 'FFFCE5CD', w: 8 },
  { col: 'Z', title: 'TKCF', w: 6 },
  // ── 반품/환불 블록 — 입고 조정(환불 줄)·입고오류 退货 상세에 있는 만큼
  { col: 'AA', title: '반품날짜', fill: 'FFD9EAD3', w: 11, key: r => r.refund && dateCell(r.refund.일자) },
  { col: 'AB', title: '업체명', fill: 'FFD9EAD3', w: 12, key: r => r.refund && r.업체명 },
  { col: 'AC', title: '수량', fill: 'FFD9EAD3', w: 6, key: r => r.refund && r.refund.수량 },
  { col: 'AD', title: '환불금액(CNY)', fill: 'FFD9EAD3', w: 10, fmt: CNY, key: r => r.refund && r.refund.환불CNY },
  { col: 'AE', title: '반품택배비', fill: 'FFD9EAD3', w: 9, fmt: CNY, key: r => r.refund && r.refund.택배비 },
  { col: 'AF', title: '반품결제금액\n(CNY)', fill: 'FFD9EAD3', w: 10, fmt: CNY },  // 샘플 수식(수수료·택배비 반영) — 시스템엔 KRW 만 있다
  { col: 'AG', title: '반품결제금액\n(KRW)', fill: 'FFD9EAD3', w: 11, fmt: KRW, key: r => r.refund && r.refund.환불KRW },
  { col: 'AH', title: '적용환율', fill: 'FFD9EAD3', w: 8, fmt: '0.00', key: r => r.refund && r.refund.환불KRW != null ? r.적용환율 : null },
  { col: 'AI', title: '적용수수료율', fill: 'FFD9EAD3', w: 8, fmt: PCT, key: r => r.refund && r.refund.환불KRW != null ? feeRate(r.customsType) : null },
  { col: 'AJ', title: '반품사유', fill: 'FFF4CCCC', w: 18, key: r => r.refund && r.refund.사유 },
  { col: 'AK', title: '결제일', fill: 'FFF4CCCC', w: 10 },      // 환불 입금일 — 시스템에 없음
  { col: 'AL', title: '退款情况\n정산현황', fill: 'FFF4CCCC', w: 14, key: r => r.refund && settleText(r.refund) },
  { col: 'AM', title: '비고\n(备注)', fill: 'FFF4CCCC', w: 16, key: r => r.refund && r.refund.메모 },
  { col: 'AN', title: '飞运手续费', fill: 'FFF4CCCC', w: 9 },   // 시스템에 없음
  { col: 'AO', title: '手续费是否退款', fill: 'FFF4CCCC', w: 9 } // 시스템에 없음
]

// 'YYYY-MM-DD' → 엑셀 날짜 일련번호(서식 yyyy-mm-dd). 형식이 다르면 글자 그대로
function dateCell(ymd) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(ymd || ''))
  if (!m) return ymd || null
  return { date: (Date.UTC(+m[1], +m[2] - 1, +m[3]) - Date.UTC(1899, 11, 30)) / 86400000 }
}

// 샘플 L 열 수식: -(협상전 총액 − 협상후 총액) / 협상전 총액. 협상이 없으면 0
export function discountRate(r) {
  const pre = Number(r.협상전_총금액) || 0
  const post = Number(r.협상후_총금액) || 0
  if (!(pre > 0) || !(post > 0)) return null
  return Math.round(-(pre - post) / pre * 10000) / 10000
}

// 통관방식별 수수료율 — 견적 공식(정본 §2)의 수수료 부분: 화주단독 3.3% · 쿠패스단독 3% · 통합 0
export function feeRate(customsType) {
  if (customsType === 'client') return 0.033
  if (customsType === 'kupass') return 0.03
  if (customsType === 'integrated') return 0
  return null
}

const PROGRESS_CN = { 대기: '待处理', 처리중: '处理中', 처리완료: '处理完成' }
const RESULT_CN = { 환불: '退款', 판매자재발송: '商家补发', 반품: '退货', 교환: '换货', 양보수령: '客户废弃', 기타: '其他' }

function settleText(f) {
  return [RESULT_CN[f.처리결과] || f.처리결과 || '', PROGRESS_CN[f.처리진행] || f.처리진행 || ''].filter(Boolean).join(' · ')
}

// 비고 — 통관방식 · 估算(견적 미발행이라 규칙으로 계산) · 별도결제 · 구매취소 등 상태 · 메모
export function remark(r) {
  const out = []
  if (!r.customsType) out.push('清关方式未定(통관방식 없음)')
  if (r.估算) out.push('估算(견적 미발행)')
  if (r.결제금액_KRW == null && r.customsType) out.push('无汇率(환율 없음)')
  if (r.별도결제) out.push('另付链接(별도결제)')
  if (r.협상후수량불일치) out.push('协商后金额待核对(협상후 금액 확인 필요 — 1688 품목 수량 불일치)')
  if (r.상태 === '구매취소' || r.상태 === '미도착종결') out.push(r.상태)
  if (r.메모) out.push(r.메모)
  return out.join(' / ')
}

// 화면 표용 칸 값 — 엑셀과 같은 key 로 꺼내고, 날짜(엑셀 일련번호)는 'YYYY-MM-DD' 글자로 되돌린다. 빈 값은 null
export function cellValue(c, r) {
  if (!c.key) return null
  const v = c.key(r)
  if (v === undefined || v === null || v === '' || v === false) return null
  if (typeof v === 'object' && v.date !== undefined) return new Date(Date.UTC(1899, 11, 30) + v.date * 86400000).toISOString().slice(0, 10)
  return v
}

// 화면 표시 글자 — 엑셀 서식(c.fmt)과 같은 자리수
export function cellText(c, v) {
  if (v === null || v === undefined) return ''
  if (typeof v !== 'number') return String(v)
  if (c.fmt === PCT) return (v * 100).toFixed(1) + '%'
  if (c.fmt === KRW) return Math.round(v).toLocaleString()
  if (c.fmt === CNY) return v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  if (c.fmt === '0.00') return v.toFixed(2)
  return String(v)
}

/**
 * 表三 엑셀(Uint8Array)
 * @param {object[]} rows 서버 행
 * @param {{ start, end, companyid }} info 머리글에 적는 조회 조건
 */
export function writePurchasedRecordXlsx(rows, info) {
  const styles = new Styles()
  const sh = new Sheet('제트배송')
  const i = info || {}
  // 1행 — 조회 조건 + 통관방식 범례(샘플 1행 M·N·O 와 같은 자리·색)
  sh.put('A1', '已采购记录(구매기록) ' + (i.start || '') + ' ~ ' + (i.end || '') + (i.companyid ? ' · ' + i.companyid : ' · 全部货主(전체)'), { font: { b: true } })
  sh.put('M1', '蓝色单独(화주단독)', { fill: BLUE, font: { b: true, color: 'FFFFFFFF' }, h: 'center' })
  sh.put('N1', '橙色单独(쿠패스단독·식검)', { fill: ORANGE, font: { b: true }, h: 'center' })
  sh.put('O1', '综合清关(통합통관)', { font: { b: true }, h: 'center' })
  // 2행 제목
  COLUMNS.forEach(c => {
    sh.put(c.col + '2', c.title, { fill: c.fill, font: { b: true, sz: 10 }, h: 'center', v: 'center', wrap: true, border: 'LRTB' })
    if (c.w) sh.width(c.col, c.w)
  })
  sh.height(2, 42)
  // 3행부터 자료
  ;(rows || []).forEach((r, idx) => {
    const rowNo = idx + 3
    COLUMNS.forEach(c => {
      if (!c.key) return
      let v = c.key(r)
      if (v === undefined || v === null || v === '' || v === false) return
      const style = { border: 'LRTB' }
      if (v && typeof v === 'object' && v.date !== undefined) { v = v.date; style.fmt = DATE_FMT } else if (typeof v === 'number' && c.fmt) style.fmt = c.fmt
      if (c.col === 'M' && r.customsType === 'client') Object.assign(style, { fill: BLUE, font: { color: 'FFFFFFFF' } })
      if (c.col === 'N' && r.customsType === 'kupass') style.fill = ORANGE
      sh.put(c.col + rowNo, v, style)
    })
  })
  return packXlsx([sh], styles, 0)
}

export function purchasedRecordFileName(info) {
  const i = info || {}
  return '已采购记录_' + (i.companyid ? i.companyid + '_' : '') + (i.start || '') + '_' + (i.end || '') + '.xlsx'
}

